'use strict';
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.StyleInjectHandler = StyleInjectHandler;
var _react = require('react');
var _gemsShared = require('@tencent/gems-shared');
function iGetInjectSchema(schema) {
    return Object.entries(schema).reduce(function(maps, param1) {
        var _param = _slicedToArray(param1, 2), key = _param[0], inject = _param[1].inject;
        if (!inject) {
            return maps;
        }
        var items = Array.isArray(inject) ? inject : [
            inject
        ];
        items.forEach(function(param) {
            var attr = param.attr, selector = param.selector, format = param.format;
            var iAttr = Array.isArray(attr) ? attr : [
                attr || key
            ];
            var iSelector = Array.isArray(selector) ? selector.join(', ') : selector;
            var iFormat = typeof format === 'function' ? format : function(i) {
                return i.toString();
            };
            if (format === 'px') {
                iFormat = _gemsShared.pxWithAuto;
            } else if (format === 'percent') {
                iFormat = _gemsShared.percent;
            }
            maps.push({
                key: key,
                attr: iAttr,
                selector: iSelector,
                format: iFormat
            });
        });
        return maps;
    }, []);
}
var getInjectSchema = (0, _gemsShared.withMemo)(iGetInjectSchema);
function formatInjectStyles(scope, style, schema) {
    return getInjectSchema(schema).reduce(function(accu, param) {
        var key = param.key, attr = param.attr, selector = param.selector, format = param.format;
        var v = style[key];
        if (!v) {
            return accu;
        }
        var value = format(v);
        accu.push("\t#".concat(scope, " ").concat(selector, " { ").concat(attr.map(function(i) {
            return "".concat(i, ": ").concat(value);
        }).join('; '), " }"));
        return accu;
    }, []).join('\n');
} // 用于处理 Schema 中的样式注入，详见：https://vision.oa.com/docs/dev-style-inject/#示例
function StyleInjectHandler(param) {
    var _instance = param.instance, key = _instance.key, _component = _instance.component, styleForm = _component.styleForm, injectStyle = _component.injectStyle, style1 = _instance.style, scope = param.scope, children = param.children;
    var cssProps = (0, _react.useMemo)(function() {
        return injectStyle ? formatInjectStyles(scope, style1, styleForm) : null;
    }, [
        style1
    ]);
    var entry = (0, _react.useMemo)(function() {
        if (!injectStyle) {
            return;
        }
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.setAttribute('class', "injected-styles-component-".concat(key));
        window.__iframeWindow.document.head.appendChild(style);
        return style;
    }, [
        key
    ]);
    (0, _react.useEffect)(function() {
        if (!injectStyle) {
            return;
        }
        entry.innerHTML = cssProps;
        window.__iframeWindow.document.head.appendChild(entry);
        return function() {
            window.__iframeWindow.document.head.removeChild(entry);
        };
    }, [
        cssProps,
        entry
    ]);
    return children;
}
